import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "./Firebase";

const functions = getFunctions(firebaseApp, "asia-south1");

export function setAdminMessageRead(messageId: string, read: boolean) {
    return httpsCallable<{ messageId: string; read: boolean }, { ok: true }>(functions, "setAdminMessageRead")({ messageId, read });
}

export function setAdminMessageResolved(messageId: string, resolved: boolean) {
    return httpsCallable<{ messageId: string; resolved: boolean }, { ok: true }>(functions, "setAdminMessageResolved")({ messageId, resolved });
}

export async function syncInterviewRequestMessages() {
    const result = await httpsCallable<Record<string, never>, { ok: true; created: number }>(functions, "syncInterviewRequestMessages")({});
    return result.data;
}
